// @ts-strict

import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ICreateTrafficSourceData } from '@app/core/services/traffic-sources/traffic-sources.types';

const icons = {
  13: 'instagram',
  12: 'twitter',
  10: 'youtube',
  14: 'snapchat',
  32: 'whatsapp',
  23: 'pinterest',
  22: 'telegram',
  35: 'tiktok',
  21: 'discord',
  33: 'linkedin',
  29: 'reddit',
  11: 'google-plus',
  31: 'tumblr',
  25: 'flickr',
  30: 'askfm',
  27: 'qzone',
  26: 'myspace',
  28: 'weibo',
  24: 'vimeo',
  18: 'vk',
  9: 'facebook'
};

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss']
})
export class SocialMediaComponent implements OnInit {
  @Input() socialMediaTypes?: ICreateTrafficSourceData[];

  @Output() selectedSocialMedia: EventEmitter<number | null> = new EventEmitter();

  public showAll: boolean = false;
  public counter: number = 0;
  public defaultNumberOfTiles: number = 5;
  public mode = {
    chooseType: 'chooseType',
    chosen: 'chosen'
  };
  public currentMode: string = 'chooseType';
  public selectedTypeId?: number;
  public currentSelectedType?: { id: number };

  constructor() {}

  ngOnInit(): void {
    this.counter = this.socialMediaTypes?.length ?? 0;
  }

  public setIcon(id: number): string {
    return icons[id as keyof typeof icons];
  }

  public onSelectSource($event: { id: number }): void {
    this.selectedTypeId = $event.id;
    this.currentMode = this.mode.chosen;
    this.currentSelectedType = $event;
    this.selectedSocialMedia.emit($event.id);
  }

  public onShowAll(): void {
    this.showAll = true;
  }

  public onChangeSocialMedia(): void {
    this.selectedSocialMedia.emit(null);
    this.currentMode = this.mode.chooseType;
  }
}
